import Header from "../Components/Header";
import { Button, Typography, Box, IconButton, Modal } from "@mui/material";
import styles from "../styles/OdontoLuzzi.css";
import { useNavigate } from "react-router-dom";
import Footer from "../Components/Footer";

const OdontoLuzzi = () => {
    const navigate = useNavigate()

    return(
        <div className="container">
            <Header/>
            <div className="content">
                <div className="bannerUs">
                    <div className="bannerUsContent">
                        <div className="usBannerLeft from-left">
                            <Typography className='bsubtitle from-left' style={{fontFamily:'Inter', color:'#041819', marginBottom:'20px', fontWeight:'700',transitionDelay: '0.1s'}}>Conheça um pouco sobre a Odonto Luzzi</Typography>
                            <div className="usLine from-left" style={{ transitionDelay: '0.2s' }}/>
                            <Typography className='bchamada' variant="h4" sx={{ fontFamily:'Inter',color: '#041819', fontWeight: 'bold', fontSize:'56px', marginBottom:'20px' }}>
                            <span className="from-left" style={{ color: '#B08E44', transitionDelay:'0.4s' }}>Compromisso</span> com a <br/> saúde do seu <span className="from-left" style={{ color: '#B08E44', transitionDelay:'0.4s' }}>sorriso.</span>
                            </Typography>
                            <Typography className="from-left" style={{ transitionDelay: '0.5s' }} sx={{marginBottom:'30px', fontFamily:'Inter', color:'#B08E44', fontSize:'24px', fontWeight:'700'}}>Nossa história</Typography>
                            <div className='usHistoryText from-left' style={{ transitionDelay: '0.5s' }}>
                            A Odonto Luzzi nasceu do sonho de levar um atendimento odontológico diferenciado, onde tecnologia, empatia e profissionalismo caminham juntos. Fundada por profissionais apaixonados por transformar vidas através do sorriso, nossa clínica vem se consolidando como referência em cuidado e confiança.

                            <p/>Desde o início, acreditamos que um bom atendimento vai além da técnica. Por isso, investimos em estrutura moderna, equipe altamente capacitada e, principalmente, no relacionamento com cada paciente. Cada detalhe da nossa história foi construído com dedicação, sempre buscando oferecer uma experiência positiva, segura e acolhedora.
                            </div>
                        </div>
                        <div className="usLineVertical"/>
                        <img src="https://odontoluzzi.com.br/images/logoUs.svg" className="logoUs from-right"/>
                    </div>
                </div>
                <div className="usDados">
                    <div className="usDadosContent">
                        <div className="us1 from-bottom">
                            <div className="usDadosTitle">30 anos</div>
                            <div className="usDadosText">no mesmo endereço.</div>
                        </div>
                        <div className="us2 from-bottom" style={{ transitionDelay: '0.1s' }}>
                            <div className="usDadosTitle">2600+</div>
                            <div className="usDadosText">casos ortodônticos<br/> finalizados.</div>
                        </div>
                        <div className="us3 from-bottom" style={{ transitionDelay: '0.2s' }}>
                            <div className="usDadosTitle">5200+</div>
                            <div className="usDadosText">pacientes<br/>sorridentes.</div>
                        </div>
                        <div className="us4 from-bottom" style={{ transitionDelay: '0.3s' }}>
                            <div className="usDadosBar"/>
                            <div className="usDadosText">CONHEÇA NOSSOS<br/>PROFISSIONAIS.</div>
                        </div>
                    </div>
                </div>
                <div className="mvvContainer">
                    <div className="mvvContent">
                        <div className="missao from-bottom"style={{ transitionDelay: '0.1s' }}>
                            <img src="https://odontoluzzi.com.br/images/icon_missao.svg"/>
                            <div className="mvvTitle">Missão</div>
                            <div className="mvvBar"/>
                            <div className="mvvText">
                                Cuidar de cada sorriso com dedicação, empatia e excelência. Oferecemos mais do que tratamentos, proporcionamos acolhimento, confiança e uma experiência leve, para que cada paciente se sinta seguro, ouvido e bem cuidado em todas as etapas da vida.
                            </div>
                        </div>
                        <div className="visao from-bottom"style={{ transitionDelay: '0.2s' }}>
                        <img src="https://odontoluzzi.com.br/images/icon_visao.svg"/>
                            <div className="mvvTitle">Visão</div>
                            <div className="mvvBar"/>
                            <div className="mvvText">
                                Ser referência em odontologia humanizada, reconhecida pela qualidade do cuidado, pelo acolhimento e pela construção de relações de confiança com cada paciente. Queremos transformar vidas através de sorrisos saudáveis, leves e verdadeiros.
                            </div>
                        </div>
                        <div className="valor from-bottom"style={{ transitionDelay: '0.3s' }}>
                        <img src="https://odontoluzzi.com.br/images/icon_valor.svg"/>
                            <div className="mvvTitle">Valor</div>
                            <div className="mvvBar"/>
                            <div className="mvvText">
                                Acreditamos no cuidado com empatia, na
                                escuta atenta e no atendimento com ética e
                                responsabilidade. Valorizamos a confiança,
                                a transparência e o compromisso com a
                                qualidade, sempre buscando inovação e
                                acolhimento em cada sorriso que passa por
                                aqui.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="estContainer">
                    <div className="estContent">
                        <div className="estHeader">
                            <div className="estHL from-left">
                                <div className="subTitle">Estrutura</div>
                                <div className="title" style={{color:'#fff'}}>Conheça nossa<br/>estrutura</div>
                            </div>
                            <div className="estHR from-right">
                                Temos os melhores produtos e equipamentos do mercado<br/>para oferecer o melhor atendimento aos nossos pacientes.
                            </div>
                        </div>
                        <div className="estBody">
                            <div className="estRight from-bottom">
                                <div className="estTextR">
                                Nossa recepção foi pensada para ser um lugar de acolhimento, onde cada detalhe
                                transmite calma, carinho e atenção. Desde o sorriso de boas-vindas até o cheirinho
                                de café fresco, tudo convida você a desacelerar. Acreditamos que o tempo na recepção também faz parte do cuidado. É o momento
                                de relaxar, tomar um cafezinho, bater um papo leve e sentir que está em um lugar
                                onde você realmente importa. Porque, para nós, um bom tratamento começa com
                                um ambiente onde você se sente bem. Aqui na Odonto Luzzi o cuidado começa no primeiro contato!
                                </div>
                                <img src="https://odontoluzzi.com.br/images/sobreNos/recepcao.png" className="estFoto"/>
                            </div>
                            <div className="estLeft from-bottom">
                                <img src="https://odontoluzzi.com.br/images/sobreNos/atendimento.png" className="estFoto"/>
                                <div className="estTextL">
                                Na Odonto Luzzi, conforto, tecnologia e atenção caminham juntos. Nossas salas de
                                atendimento são modernas, equipadas com o que há de mais atual em odontologia,
                                garantindo segurança, precisão e mais tranquilidade em cada etapa do tratamento.
                                Mais do que estrutura, oferecemos cuidado humano. Com o hábito de explicar tudo
                                com calma, tirando dúvidas e deixando você seguro antes de qualquer procedimento.
                                Acreditamos que informação também é uma forma de acolhimento e aqui, cada
                                detalhe é pensado para que você se sinta bem, confiante e em boas mãos.
                                </div>
                            </div>
                            <div className="estRight from-bottom">
                                <div className="estTextR">
                                Na Odonto Luzzi, nossa sala de procedimento conta com uma cadeira
                                confortável e equipamentos modernos, pensados para garantir sua segurança e
                                bem-estar durante o atendimento. Tudo é preparado para que você se sinta
                                tranquilo, com tecnologia de ponta ao alcance do cuidado humano.

                                Aqui, conforto e precisão caminham juntos para que cada procedimento seja
                                feito com atenção e carinho.
                                </div>
                                <img src="https://odontoluzzi.com.br/images/sobreNos/procedimento.png" className="estFoto"/>
                            </div>
                            <div className="estLeft from-bottom">
                                <img src="https://odontoluzzi.com.br/images/sobreNos/esterilizacao.png" className="estFoto"/>
                                <div className="estTextL">
                                Na Odonto Luzzi, a segurança e a saúde dos nossos pacientes são prioridade em cada
                                detalhe especialmente na higienização e esterilização dos equipamentos. Contamos com
                                um laboratório interno dedicado a garantir que todos os instrumentos sejam limpos e
                                esterilizados com rigor absoluto.

                                Utilizamos protocolos modernos e equipamentos de última geração para eliminar
                                qualquer risco de contaminação. Esse cuidado reforça nosso compromisso com um
                                atendimento seguro, transparente e de qualidade, para que você possa se sentir
                                tranquilo em todas as etapas do tratamento.
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className="mapContainer">
                    <div className="mapContent" style={{backgroundColor:'#B08E44'}}>
                        <div className="subTitle from-bottom" style={{color:'#041819'}}>Localização</div>
                        <div className="title from-bottom" style={{color:'#fff'}}>Onde Estamos</div>
                        <div className="titleLine from-bottom" style={{backgroundColor:'#041819'}}/>
                        <iframe className='map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3617.207059696882!2d-53.46348442384214!3d-24.959068914426737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94f3d413fff6f933%3A0x8df61cebf00b39bb!2sOdonto%20Luzzi%20-%20Luzzi%20Odontologia%20-%20Implante%20Dent%C3%A1rio%2C%20Clareamento%20Dental%2C%20Pr%C3%B3teses%2CAparelho%20Ortod%C3%B4ntico%2C%20Facetas%20em%20Cascavel!5e0!3m2!1spt-BR!2sbr!4v1755541546358!5m2!1spt-BR!2sbr" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> 
                    </div>
                </div>

            </div>
            <Footer/>
        </div>
        
    )
}
export default OdontoLuzzi;